import { render, staticRenderFns } from "./sendInvit.vue?vue&type=template&id=50dd46b7&scoped=true&"
import script from "./sendInvit.vue?vue&type=script&lang=js&"
export * from "./sendInvit.vue?vue&type=script&lang=js&"
import style0 from "./sendInvit.vue?vue&type=style&index=0&id=50dd46b7&lang=less&scoped=true&"
import style1 from "./sendInvit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd46b7",
  null
  
)

export default component.exports